import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_358: DocMigration = {
  maxSchemaVersion: "0.0.358",
  description:
    "Remove option template override merges that led to malformed options and clean up the related overrides",
  apply(json: any) {
    for (const optionSetId in json.optionSets) {
      for (const optionId in json.optionSets[optionSetId].options) {
        const option = json.optionSets[optionSetId].options[optionId];
        if (!option.parentId || !option.id) {
          delete json.optionSets[optionSetId].options[optionId];
        }
      }
    }
    for (const id in json.optionSetOverrides) {
      const override = json.optionSetOverrides[id];
      if (override.options) {
        const optionSet = json.optionSets[override.optionSetId];
        for (const optionId in override.options) {
          if (!optionSet.options[optionId]) {
            delete override.options[optionId];
          }
        }
        if (!Object.keys(override.options).length) {
          delete json.optionSetOverrides[id];
        }
      }
    }
    return json;
  },
};

export default migration_0_0_358;
